import {DragIndicator} from '@mui/icons-material'
import {Chip, Divider} from '@mui/material'
import React from 'react'
import QuestionCategoryBadge from './QuestionCategoryBadge'

export default function QuestionRow({
  text,
  index,
  onChange,
  onReorder,
  categoryName,
  typeLabel,
}) {
  return (
    <div
      className="questions-list"
      onClick={e => onChange(index)}
      draggable
      onDragStart={e => {
        e.target.style.cursor = 'grabbing'
        e.dataTransfer.setData('text/plain', index)
      }}
      onDragOver={e => {
        e.preventDefault()
        e.target.style.cursor = 'grabbing'
      }}
      onDragEnter={e => {
        e.preventDefault()
        e.target.style.cursor = 'grabbing'
        e.target.style.opacity = '0.5'
      }}
      onDragLeave={e => {
        e.preventDefault()
        e.target.style.cursor = 'grab'
        e.target.style.opacity = '1'
      }}
      onDrop={e => {
        e.preventDefault()
        const from = Number.parseInt(e.dataTransfer.getData('text/plain'), 10)
        const to = index
        e.target.style.cursor = 'grab'
        e.target.style.opacity = '1'
        onReorder(from, to)
      }}
    >
      <DragIndicator sx={{fontSize: '20px'}} style={{cursor: 'grab'}} />
      <div className="question-no">{index + 1}</div>
      <Divider orientation="vertical" variant="middle" flexItem />{' '}
      <div className="question-txt">
        {typeLabel && (
          <Chip label={typeLabel} size="small" variant="outlined" sx={{mr: 1}} />
        )}
        {categoryName && <QuestionCategoryBadge categoryName={categoryName} />}
        <div>{text}</div>
      </div>
    </div>
  )
}
